// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v1.0.23-0-gdad2279-dirty",
    "hash": "gdad2279",
    "distance": 0,
    "tag": "v1.0.23",
    "semver": {
        "raw": "v1.0.23",
        "major": 1,
        "minor": 0,
        "patch": 23,
        "prerelease": [],
        "build": [],
        "version": "1.0.23"
    },
    "suffix": "0-gdad2279-dirty",
    "semverString": "1.0.23",
    "version": "0.0.0",
    "buildDate": "3/3/2022, 5:13:36 PM"
};
/* tslint:enable */
